import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Token fallback: also store in localStorage for cases where cookie isn't sent
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("albaker_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    return Promise.reject(err);
  }
);

export const formatApiError = (err, fallback = "حدث خطأ ما، حاول مرة أخرى.") => {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" · ");
  }
  if (typeof detail === "object" && detail.msg) return detail.msg;
  return String(detail);
};
